// extracted by mini-css-extract-plugin
export default {"container":"uni_1yfRa"};